import { useStoreConfig } from 'src/components/AppShell/ConfigProvider';

import type { Data } from './get-delivery-messages';
import type { DeliveryMessageConfig } from './types';
import { getDeliveryMessage } from './get-delivery-messages';

export type UseDeliveryMessagesProps = Omit<DeliveryMessageConfig, 'isAvailable' | 'isLeadTimeEnabled'>;

function fetchMessages(cmsBlocks: Data, config: UseDeliveryMessagesProps) {
    const availableMessage = getDeliveryMessage(cmsBlocks, {
        ...config,
        isAvailable: true,
    });

    const unavailableMessage =
        getDeliveryMessage(cmsBlocks, {
            ...config,
            disableLeadTime: false,
            isAvailable: false,
        }) ?? 'Currently unavailable';

    return { availableMessage, unavailableMessage };
}

export function useDeliveryMessages(props: UseDeliveryMessagesProps) {
    const { cmsBlocks, lead_time_message_enabled } = useStoreConfig();

    const disableLeadTime = props.deliveryType === 'clickAndCollect' && !lead_time_message_enabled;

    return fetchMessages(cmsBlocks, {
        ...props,
        disableLeadTime,
    });
}
